import React from "react";
import Button from "@mui/material/Button";
import "./ButtonView.css";
const ButtonView = (props) => {
  return (
    <Button
      variant={props.variant}
      className={
        props.className ? `button-style ${props.className}` : "button-style"
      }
      sx={props.style}
      startIcon={props.startIcon}
      disabled={props.disabled ? props.disabled : false}
      onClick={props.onClick}
      data-testid={props?.label}
    >
      {props.label}
    </Button>
  );
};

export default ButtonView;
